import { useNodesData } from "@xyflow/react";

import { usePipelineBuilder } from "V2.0/HomePages/Pipelines/PipelineBuilder/PipelineBuilderProvider";

import { NodeType } from "../../Models/NodeType";
import { TEndNode } from "../../Models/End";
import { TConditionalNode } from "../../Models/Conditional";
import { TAssistantNodeConfig } from "../../Models/Assistant";

import { validateNodeConfig } from "../../NodeConfigure/nodeValidation";

import usePipelineNodeExecution from "./usePipelineNodeExecution";

export default usePipelineNode;

function getSubType(type, pipelineNodeConfig) {
  switch (type) {
    case NodeType.ASSISTANT:
      return (pipelineNodeConfig as TAssistantNodeConfig).action;
    case NodeType.CONDITIONAL:
      return (pipelineNodeConfig as TConditionalNode).mode;
    case NodeType.END:
      return (pipelineNodeConfig as TEndNode["config"]).endAction;
    case NodeType.DELAY:
    case NodeType.WEBHOOK_TRIGGER:
    case NodeType.EXTERNAL_API:
    case NodeType.WAIT_FOR_CALLBACK:
    default:
      return "default";
  }
}

function usePipelineNode<T>(id) {
  const {
    onAddNode,
    onConfigureNode,
    isPanelActive,
    onDelete,
    isPreviewMode = false,
    getNodeExecution,
    workspaceId,
    pipelineId,
  } = usePipelineBuilder();

  const { isExecuted, executedNodeStatus } = usePipelineNodeExecution(
    id,
    isPreviewMode,
    getNodeExecution,
  );
  const internalNode = useNodesData(id);
  const data: T = internalNode.data as T;

  const handleAdd = () => {
    const type = internalNode.type;
    const subType = getSubType(type, data);

    const { isValid, errors } = validateNodeConfig(type, subType, data);

    if (!isValid) {
      onConfigureNode(internalNode, errors);
      return;
    }

    onAddNode(internalNode);
  };

  return {
    data,
    onDelete,
    handleAdd,
    isExecuted,
    pipelineId,
    workspaceId,
    internalNode,
    isPanelActive,
    isPreviewMode,
    onConfigureNode,
    executedNodeStatus,
  };
}
